import * as vp from 'vopay';
import styles from './AvailableBalance.module.scss';

type AvailableBalanceProps = {
  availableBalance: string;
  currency?: vp.SupportedCurrencies;
};

const AvailableBalance: React.FC<AvailableBalanceProps> = ({ availableBalance, currency = 'CAD' }) => {
  return (
    <div className={styles.balanceView}>
      <div className={styles.balanceHeader}>Available Balance</div>
      <div className={styles.balanceValue}>
        {currency} {vp.formattedCurrency(availableBalance)}
      </div>
    </div>
  );
};

export default AvailableBalance;
